import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'input[dateString]'
})
export class InputDateStringDirective {
  private navigationKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'Home',
    'End',
    'ArrowLeft',
    'ArrowRight',
    'Clear',
    'Copy',
    'Paste'
  ];

  constructor(private _el: ElementRef) { }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    if (
      this.navigationKeys.indexOf(e.key) > -1 || // Allow: navigation keys: backspace, delete, arrows etc.
      (e.key === 'a' && e.ctrlKey === true) || // Allow: Ctrl+A
      (e.key === 'c' && e.ctrlKey === true) || // Allow: Ctrl+C
      (e.key === 'v' && e.ctrlKey === true) || // Allow: Ctrl+V
      (e.key === 'x' && e.ctrlKey === true) || // Allow: Ctrl+X
      (e.key === 'a' && e.metaKey === true) || // Allow: Cmd+A (Mac)
      (e.key === 'c' && e.metaKey === true) || // Allow: Cmd+C (Mac)
      (e.key === 'v' && e.metaKey === true) || // Allow: Cmd+V (Mac)
      (e.key === 'x' && e.metaKey === true) // Allow: Cmd+X (Mac)
    ) {
      // let it happen, don't do anything
      return;
    }

    // Ensure that it is a number and stop the keypress
    const pattern = /[0-9/]/g;
    const reg = new RegExp('/', 'g');
    const val = this._el.nativeElement.value ? this._el.nativeElement.value : '';
    const match = val.match(reg);
    if (!pattern.test(e.key) || (match ? match : []).length === 2 && e.key === '/') {
      e.preventDefault();
    }
  }

  /*@HostListener('input', ['$event']) onInputChange(event) {
    if (event.target.value) {
      // todo this function add slash(/)
      // if ([2, 5].includes(event.target.value.length)) {
      //   event.target.value = event.target.value + '/';
      // }
      //
    }
  }*/
}
